import React from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext/index';

export function withSnackbarContext(WrappedComponent) {
  return function SnackbarContextWrapper(props) {
    const { displayErrorMessage, displaySuccess } = useSnackbarContext();

    return (
      <WrappedComponent
        displayErrorMessage={displayErrorMessage}
        displaySuccess={displaySuccess}
        {...props}
      />
    );
  };
}
